import { getKSwitch } from './kswitch';

const PREFIX = 'KdsReactMinBundleVersion';

const cache = {};
export const getMinBundleVersionById = async (bundleId) => {
    if (cache[bundleId]) {
        return cache[bundleId];
    }

    const res = await getKSwitch([
        {
            key: `${PREFIX}${bundleId}`,
        },
    ]);
    cache[bundleId] = res?.[0]?.value || 0;

    console.log('minBundleVersion', cache);

    return cache[bundleId] || 0;
};
